import { useProjectPermissions } from 'hooks/useProjectPermissions'
import LinkPreview from 'ui/components/LinkPreview'
import { LinkStyled, TextStyled } from './styled'

const WikiLink = ({ link }) => {
  const { isManagerOrAdmin } = useProjectPermissions()

  return (
    <LinkStyled>
      <LinkPreview link={link} />
      {!isManagerOrAdmin && (
        <TextStyled>
          Для получения доступа к странице проекта обратитесь к Руководителю
          проекта
        </TextStyled>
      )}
    </LinkStyled>
  )
}

export default WikiLink
